import { Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { ToasterService } from '../../../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../../../components/toaster/toaster.model';
import { StyleTheme, ThemeRequest } from './theme.model';
import { Store } from '@ngrx/store';
import { fetchTheme } from './store/theme.actions';
import { themeSelector } from './store/theme.selectors';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(
    private winRef: WindowRef,
    private store: Store,
    private toasterService: ToasterService,
  ) {}

  fetch() {
    this.store.dispatch(fetchTheme());
  }

  get() {
    return this.store.select(themeSelector);
  }

  applyTheme(themeRequest: ThemeRequest) {
    if (!themeRequest.isPristine && !themeRequest.isLoading) {
      if (themeRequest.hasError) {
        this.toasterService.init({
          type: TOASTER_TYPE.DANGER,
          content: themeRequest.message || '',
        });
      } else {
        const css = this.convertToCSS(themeRequest.theme!);
        this.injectStyle(css, themeRequest.theme!);
      }
    }
  }

  private convertToCSS(style: StyleTheme): string {
    return `
			:root {
				--cx-text-common-color                : ${style.core?.common?.colors?.text};
				--cx-link-common-color                : ${style.core?.common?.colors?.link};
				--cx-page-common-background-color     : ${style.core?.common?.colors?.background};
 
				--cx-simple-card-bg-color             : ${style.core?.simpleCard?.colors?.background};
				--cx-simple-card-bg-transparent-color : ${style.core?.simpleCard?.colors?.backgroundTransparent};
 
				--cx-color-primary                    : ${style.theme?.colors?.primary};
				--cx-color-secondary                  : ${style.theme?.colors?.secondary};
				--cx-color-success                    : ${style.theme?.colors?.success};
				--cx-color-danger                     : ${style.theme?.colors?.danger};
				--cx-color-warning                    : ${style.theme?.colors?.warning};
				--cx-color-info                       : ${style.theme?.colors?.info};
 
				--cx-color-primary-light              : ${style.theme?.colors?.light?.primary};
				--cx-color-secondary-light            : ${style.theme?.colors?.light?.secondary};
				--cx-color-success-light              : ${style.theme?.colors?.light?.success};
				--cx-color-danger-light               : ${style.theme?.colors?.light?.danger};
				--cx-color-warning-light              : ${style.theme?.colors?.light?.warning};
				--cx-color-info-light                 : ${style.theme?.colors?.light?.info};
 
				--cx-color-primary-dark               : ${style.theme?.colors?.dark?.primary};
				--cx-color-secondary-dark             : ${style.theme?.colors?.dark?.secondary};
				--cx-color-success-dark               : ${style.theme?.colors?.dark?.success};
				--cx-color-danger-dark                : ${style.theme?.colors?.dark?.danger};
				--cx-color-warning-dark               : ${style.theme?.colors?.dark?.warning};
				--cx-color-info-dark                  : ${style.theme?.colors?.dark?.info};
			} 
		`;
  }

  private injectStyle(css: string, style: StyleTheme): void {
    const $style = this.winRef.document.createElement('style');
    $style.setAttribute('data-theme', style.name || '');
    $style.innerHTML = css;
    this.winRef.document.head.appendChild($style);
  }
}
